import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { getFriendlyUrlFromRoute } from "../helpers/route-params";
import { OrderCheckService } from "../services/order-check.service";

@Injectable({
  providedIn: "root",
})
export class CanActivateMenuPageGuard {
  constructor(
    private orderCheckService: OrderCheckService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | UrlTree {
    const friendlyUrl = getFriendlyUrlFromRoute(route);
    const parameterization = this.orderCheckService.getParameterization();
    const orderCheck = this.orderCheckService.getOrderCheckStorage();

    if (!friendlyUrl) {
      return this.router.createUrlTree(["/empresa-nao-encontrada"]);
    }

    if (
      !parameterization ||
      parameterization.FriendlyUrl?.toLowerCase() !== friendlyUrl.toLowerCase() ||
      this.orderCheckService.isLoginSessionExpired(orderCheck) ||
      !parameterization.StoreIsOpen ||
      !parameterization.CanReceiveOrders ||
      !orderCheck?.OperatorLogin ||
      orderCheck.OperatorLogin.length === 0
    ) {
      return this.router.createUrlTree(["/", friendlyUrl, "login"]);
    }

    if (!orderCheck || orderCheck.CompanyId !== parameterization.CompanyId) {
      return this.router.createUrlTree(["/", friendlyUrl, "login"]);
    }

    return true;
  }
}
